<template>
  <div class="resultTaipeiPASS modal-alert">
    <t-pass-msg ref="tPassMsg"></t-pass-msg>
    <t-pass-directions ref="tPassDirections" :content="content"></t-pass-directions>
  </div>
</template>

<script>
export default {
  name: 'ResultTaipeiPASS',

  data() {
    return {
      msg: '收據號碼：ZX1100000008',
      apiLoading: false,
      content: [
        {
          value: '1',
          text:
            '本電子收據系統由機關依個別法規規定應載明事項辦理，對收據劇內容有疑義，請逕洽收據開立機關承辦人。',
        },
        {
          value: '2',
          text: '收據如經作廢，最新狀態請依平台顯示為主。',
        },
        {
          value: '3',
          text: '每張收據僅能歸戶一次，取得收據者可歸戶至台北通帳戶(未限制須為繳款人本人)。',
        },
        {
          value: '3',
          text: '僅限開立日期一年內之收據資料可供查詢及歸戶。',
        },
      ],
    };
  },

  mounted() {
    $('#app').css('background-color', '#fff');
    $('#app').css('background-image', 'none');
    $('#app').css('padding-top', '120px');
    this.$refs.tPassMsg.changeMsgIcon(
      'success',
      '收據號碼：ZX1100000008',
      '已完成歸戶',
      '歸戶完成',
      {
        btnName: '查看明細',
        isShowBtn: true,
      }
    );
  },
};
</script>
